module.exports = __webpack_public_path__ + "img/lotery-rewards-2.8fd34302.jpg";